import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductState } from "src/types/product.types";

const initialState: ProductState = {
  createProduct: {
    loading: false,
    data: null,
    error: null,
  },
  editProduct: {
    loading: false,
    data: null,
    error: null,
  },
  productList: {
    loading: false,
    data: null,
    error: null,
  },
  deleteProduct: {
    loading: false,
    data: null,
    error: null,
  },
  getProduct: {
    loading: false,
    data: null,
    error: null,
  },
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    // create product actions
    createProductRequest: (state, action: PayloadAction<any>) => {
      state.createProduct.loading = true;
      state.createProduct.data = null;
      state.createProduct.error = null;
    },
    createProductSuccess: (state, action: PayloadAction<any>) => {
      state.createProduct.loading = false;
      state.createProduct.data = action.payload;
      state.createProduct.error = null;
    },
    createProductError: (state, action: PayloadAction<string>) => {
      state.createProduct.loading = false;
      state.createProduct.data = null;
      state.createProduct.error = action.payload;
    },
    resetCreateProduct: (state) => {
      state.createProduct = {
        loading: false,
        data: null,
        error: null,
      };
    },

    // edit product actions
    editProductRequest: (state, action: PayloadAction<any>) => {
      state.editProduct.loading = true;
      state.editProduct.data = null;
      state.editProduct.error = null;
    },
    editProductSuccess: (state, action: PayloadAction<any>) => {
      state.editProduct.loading = false;
      state.editProduct.data = action.payload;
      state.editProduct.error = null;
    },
    editProductError: (state, action: PayloadAction<string>) => {
      state.editProduct.loading = false;
      state.editProduct.data = null;
      state.editProduct.error = action.payload;
    },
    resetEditProduct: (state) => {
      state.editProduct = {
        loading: false,
        data: null,
        error: null,
      };
    },

    // get product list actions
    getProductListRequest: (
      state,
      action: PayloadAction<{
        page: number;
        limit: number;
        search?: string;
        status?: "active" | "inactive";
        categoryId?: string;
        brandId?: string;
        unitId?: string;
      }>
    ) => {
      state.productList.loading = true;
      state.productList.data = null;
      state.productList.error = null;
    },
    getProductListSuccess: (state, action: PayloadAction<any>) => {
      state.productList.loading = false;
      state.productList.data = action.payload;
      state.productList.error = null;
    },
    getProductListError: (state, action: PayloadAction<string>) => {
      state.productList.loading = false;
      state.productList.data = null;
      state.productList.error = action.payload;
    },
    resetProductList: (state) => {
      state.productList = {
        loading: false,
        data: null,
        error: null,
      };
    },

    // delete product actions
    deleteProductRequest: (state, action: PayloadAction<string>) => {
      state.deleteProduct.loading = true;
      state.deleteProduct.data = null;
      state.deleteProduct.error = null;
    },
    deleteProductSuccess: (state, action: PayloadAction<any>) => {
      state.deleteProduct.loading = false;
      state.deleteProduct.data = action.payload;
      state.deleteProduct.error = null;
    },
    deleteProductError: (state, action: PayloadAction<string>) => {
      state.deleteProduct.loading = false;
      state.deleteProduct.data = null;
      state.deleteProduct.error = action.payload;
    },
    resetDeleteProduct: (state) => {
      state.deleteProduct = {
        loading: false,
        data: null,
        error: null,
      };
    },

    // get single product actions
    getProductRequest: (state, action: PayloadAction<string>) => {
      state.getProduct.loading = true;
      state.getProduct.data = null;
      state.getProduct.error = null;
    },
    getProductSuccess: (state, action: PayloadAction<any>) => {
      state.getProduct.loading = false;
      state.getProduct.data = action.payload;
      state.getProduct.error = null;
    },
    getProductError: (state, action: PayloadAction<string>) => {
      state.getProduct.loading = false;
      state.getProduct.data = null;
      state.getProduct.error = action.payload;
    },
    resetGetProduct: (state) => {
      state.getProduct = {
        loading: false,
        data: null,
        error: null,
      };
    },
  },
});

export const {
  // create product actions
  createProductRequest,
  createProductSuccess,
  createProductError,
  resetCreateProduct,

  // edit product actions
  editProductRequest,
  editProductSuccess,
  editProductError,
  resetEditProduct,

  // get product list actions
  getProductListRequest,
  getProductListSuccess,
  getProductListError,

  // delete product actions
  deleteProductRequest,
  deleteProductSuccess,
  deleteProductError,
  resetDeleteProduct,

  // get single product actions
  getProductRequest,
  getProductSuccess,
  getProductError,
  resetGetProduct,
} = productSlice.actions;
export default productSlice.reducer;
